import {
  TOpenSourceLicense,
} from './table-open-source-licenses.ts';

const licenseColumn: Record<keyof TOpenSourceLicense, string> = {
  name: 'Biblioteka / Projekt',
  version: 'Wersja',
  license: 'Licencja',
  url: 'Strona główna',
  notice: 'Treść licencji',
  notice_url: 'URL licencji',
  package_url: 'Adres URL w repozytorium pakietów',
};

export default {
  licenseColumn,
};
